import { connect } from 'react-redux';
import EnhancementButton from '../enhancementButton/enhancementButton';
import { trackAdobeEvent } from '../../../utils/trackers/adobe';

const mapStateToProps = (state, ownProps) => {
  const {
    extras: {
      data = [],
    },
  } = state;

  return {
    active: !!(ownProps?.['aria-expanded']),
    canShow: data.length > 0,
    heading: `Extras (${data.length})`,
    attributeId: 'extras',
    restoreFocus: false,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  closeSidePanel: () => ownProps.onClick(),
  openSidePanel: () => {
    trackAdobeEvent('buttonClick', {
      buttonType: 'menu:extras-opened',
    });
    ownProps.onClick();
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EnhancementButton);
